<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <Left v-on:nodeClicked='nodeClicked'></Left>
    </template>
    <template v-slot:right_view>
      <Right v-bind:nodeParam='nodeParam'></Right>
    </template>
  </BasicLayout>
</template>

<script>

import BasicLayout from '../../../layouts/BasicLayout';
import Left from '../../../components/pmConfig/4gproject/IndicatorManagement/left/left';
import Right from '../../../components/pmConfig/4gproject/IndicatorManagement/right/right';

export default {
  name: 'IndicatorManagementPage',
  components: {
    BasicLayout,
    Left,
    Right,
  },
  data() {
    return {
      left: {
        show: true,
        name: `${this.$t('Pm.performanceIndicatorManage')}`
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.performanceIndicatorManage')}`
      },
      nodeParam: {
        netypeid: '',
        measureobjecttypecode: '',
        countertypeid: '',
        neversionid: '',
        text: {},
        isLeaf: false
      }
    };
  },
  methods: {
    nodeClicked(payload) {
      this.nodeParam = payload.nodeParam;
      // console.log('first',payload,this.nodeParam);
    }
  }
};
</script>

<style scoped>

</style>
